/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { compose } from "redux";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { createLoadingSelector, createErrorSelector, errorActions } from "@a1/core";
import { processActions } from "../../reducer/processReducer";

import logoSplash from "../../images/logo_splash.png";

const actionsNames = ["CHECK_TOKEN"];

class ConfirmEmail extends Component {
  componentDidMount() {
    document.title = "Потвърждаване на e-mail - A1 Xplore TV GO";

    const { history, clearErrors, checkToken, setToken } = this.props;

    clearErrors(actionsNames);

    const tokenParts = history.location.pathname.split("/");
    let tokenString = tokenParts && tokenParts.length > 2 ? tokenParts[2] : "";

    if (tokenString === "") {
      try {
        const tS = sessionStorage.getItem("token");
        if (tS && tS !== null && tS.length) tokenString = tS;
      } catch (err) {
        tokenString = "";
      }
    }

    if (tokenString !== "" && tokenString !== null) {
      try {
        sessionStorage.setItem("token", tokenString);
      } catch (err) {
        /* */
      }

      setToken(tokenString);
      checkToken(tokenString);
    }

    return false;
  }

  componentDidUpdate(prevProps) {
    const { loading, history, process, error } = this.props;

    if (!loading && !(error && error.length) && process.token && process.checkTokenError === null) {
      // Typical usage (don't forget to compare props):
      if (process.isNew !== prevProps.process.isNew) {
        history.push("/account");
      }
    }

    return false;
  }

  render() {
    const { loading, error, process } = this.props;

    const divLoading = loading ? (
      <div className="loading">
        <div className="spinner-border" />
      </div>
    ) : null;

    const divErrorToken =
      process.checkTokenError !== null || !(process.token && process.token.length) ? (
        <>
          <h1 className="tag-title">Грешка</h1>
          <div className="tag-content">
            <p>
              Линкът за потвърждение на e-mail адреса е изтекъл.
              <br />
              Необходимо е да направиш регистрация отново.
            </p>
          </div>
          <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
            <NavLink to="/start" className="tag-color-red">
              Изпрати нов e-mail
            </NavLink>
          </div>
        </>
      ) : null;

    const divErrorRequest =
      error && error.length ? (
        <>
          <h1 className="tag-title">Грешка</h1>
          <div className="tag-content">
            <p>Възникна грешка на сървъра:</p>
            <h3 className="tag-color-red no-break-out">{error}</h3>
          </div>
          <div className="tag-content tag-content__help" style={{ marginTop: "40px" }}>
            Моля, опитайте пак по-късно.{" "}
            <a href="https://help.a1.bg/tv/a1xploretv" className="tag-color-red">
              Помощ
            </a>
          </div>
        </>
      ) : null;

    const divError = divErrorRequest || divErrorToken;

    return (
      <div className="page page-confirm">
        <div className="header-bg" />

        <div className="container container--small">
          {divLoading}

          <div className="container-head">
            <img src={logoSplash} alt="" />
          </div>

          <div className="container-body">{divError}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    process: state.process,
    loading: createLoadingSelector(actionsNames)(state),
    error: createErrorSelector(actionsNames)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearErrors: actions => dispatch(errorActions.clearErrors(actions)),
    setToken: token => dispatch(processActions.setToken(token)),
    checkToken: token => dispatch(processActions.checkToken(token)),
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ConfirmEmail);
